import React from 'react';
import LearnBreadcrumb from '../../components/LearnBreadcrumb';

const trophicLevels = [
  {
    name: 'Producer',
    img: require('../../img/card_symbols/trophic_level_symbols/producer.png'),
    cardImg: require('../../img/learn/trophic_levels/producer_card.png'),
    description: [
      "Producers, also known as autotrophs, form the base of every food web. They are organisms that produce their own food, primarily through photosynthesis (using sunlight) or chemosynthesis (using chemical reactions). Plants, algae, and some bacteria are examples of producers.",
      "Producers convert inorganic compounds into organic compounds, making energy available to other organisms in an ecosystem. Without producers, higher trophic levels would not exist, as they are the original source of energy for nearly all life on Earth."
    ]
  },
  {
    name: 'Herbivore',
    img: require('../../img/card_symbols/trophic_level_symbols/herbivore.png'),
    cardImg: require('../../img/learn/trophic_levels/herbivore_card.png'),
    description: [
      "Herbivores are primary consumers that obtain energy by feeding exclusively on producers (plants or algae). They are a crucial link in the food chain, transferring energy from plants to higher trophic levels. Examples include deer, rabbits, cows, and many insects.",
      "Herbivores have evolved various adaptations for consuming plant matter, such as specialized teeth for grinding, long digestive tracts, and symbiotic microorganisms to help break down cellulose. Their feeding habits can significantly impact plant populations and ecosystem structure."
    ]
  },
  {
    name: 'Omnivore',
    img: require('../../img/card_symbols/trophic_level_symbols/omnivore.png'),
    cardImg: require('../../img/learn/trophic_levels/omnivore_card.png'),
    description: [
      "Omnivores are consumers that have a diet consisting of both plants and animals. They occupy multiple trophic levels, acting as primary, secondary, or even tertiary consumers depending on what they are eating. Humans, bears, raccoons, and some birds are common examples of omnivores.",
      "This dietary flexibility allows omnivores to adapt to a wider range of food sources and environments, making them highly adaptable. Their role in ecosystems can be complex, influencing both plant and animal populations."
    ]
  },
  {
    name: 'Carnivore',
    img: require('../../img/card_symbols/trophic_level_symbols/carnivore.png'),
    cardImg: require('../../img/learn/trophic_levels/carnivore_card.png'),
    description: [
      "Carnivores are consumers that primarily obtain energy by feeding on other animals. They can be secondary consumers (eating herbivores) or tertiary consumers (eating other carnivores). Lions, wolves, sharks, and eagles are examples of carnivores.",
      "Carnivores have evolved specialized adaptations for hunting and consuming prey, such as sharp teeth, claws, keen senses, and predatory behaviors. They play a vital role in regulating prey populations and maintaining the balance of ecosystems."
    ]
  },
  {
    name: 'Apex Predator',
    img: require('../../img/card_symbols/trophic_level_symbols/apex.png'),
    cardImg: require('../../img/learn/trophic_levels/apex_card.png'),
    description: [
      "Apex predators are top-level carnivores that have no natural predators in their ecosystem. They sit at the very top of the food chain and play a critical role in maintaining the health and balance of their ecosystems by controlling populations of lower trophic levels. Examples include orcas, jaguars, and eagles.",
      "The presence and health of apex predators are often indicators of a robust ecosystem. Their removal can lead to trophic cascades, where changes at the top of the food chain have cascading effects throughout the entire ecosystem, often resulting in overpopulation of herbivores and degradation of plant life."
    ]
  },
  {
    name: 'Decomposer',
    img: require('../../img/card_symbols/trophic_level_symbols/decomposer.png'),
    cardImg: require('../../img/learn/trophic_levels/decomposer_card.png'),
    description: [
      "Decomposers are organisms that break down dead organic matter, returning essential nutrients to the soil and atmosphere. They are crucial for nutrient cycling and the continuation of life in ecosystems. Fungi and bacteria are examples of decomposers.",
      ""
    ]
  },
];

function TrophicLevel() {
  return (
    <div className="container py-4">
      <LearnBreadcrumb />
      <h1 className="display-4 mb-4 text-center">Trophic Level</h1>
      <p className="lead text-center mb-5">Explore trophic levels and their importance in ecosystems.</p>

      {trophicLevels.map((level) => (
        <div key={level.name} className="mb-5">
          <div className="row align-items-start">
            {/* Image column (left) */}
            <div className="col-12 col-md-2 mb-3 mb-md-0 d-flex justify-content-center">
              <div style={{ maxWidth: '200px', textAlign: 'center' }}>
                <img
                  src={level.img}
                  alt={level.name}
                  className="img-fluid"
                  style={{ maxHeight: '150px', objectFit: 'contain' }}
                />
                <h3 className="mt-3">{level.name}</h3>
              </div>
            </div>
            {/* Description column (middle) */}
            <div className="col-12 col-md-8">
              {level.description.map((paragraph, idx) => (
                <p key={idx} className="mb-3">
                  {paragraph}
                </p>
              ))}
            </div>
            {/* Card Image column (right) */}
            <div className="col-12 col-md-2 d-flex justify-content-center">
              <img
                src={level.cardImg}
                alt={`${level.name} card`}
                className="img-fluid"
                style={{ maxHeight: '200px', objectFit: 'contain' }}
              />
            </div>
          </div>
          <hr className="my-4" />
        </div>
      ))}
    </div>
  );
}
export default TrophicLevel;